class WaterRipples {
  constructor() {
    this.init();
  }

  init() {
    try {
      $('.banner__content').ripples({
        resolution: 1080,
        perturbance: 0.01,
        interactive: true,
      });
    } catch (e) {
      console.log(e);
    }
  }
}

new WaterRipples();